/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Alarms_Form_Objectinstance_Label1Inputs */



/**
* | output |
* | --- |
* | "Instance" |
*
* @param {Alarms_Form_Objectinstance_Label1Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const alarms_form_objectinstance_label1 = /** @type {((inputs?: Alarms_Form_Objectinstance_Label1Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Alarms_Form_Objectinstance_Label1Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Instance")
	return /** @type {LocalizedString} */ ("Instance")
});
export { alarms_form_objectinstance_label1 as "alarms_form_objectInstance_label" }